import angular from "angular";
import modal from "angular-ui-bootstrap/src/modal";

export default angular
  .module("controllers.marketablesShow", [
    modal,
  ])
  .controller("MarketableShowController", [
    "$uibModal",
    "attachments", // defined on rails view

    function(
      $uibModal,
      attachments,
    ) {
      this.attachments = attachments || [];

      this.copyRelatedLink = function(link) {
        const selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = link;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
        $(".copied_container").addClass("visible");
        setTimeout(() => {
          $(".copied_container").removeClass("visible");
        }, 5000)
      }

      $(".tooltip_tooltipster").tooltipster({
        theme: "tooltipster-light",
        animationDuration: 200,
        delay: 0,
        side: ["bottom", "top", "right", "left"],
      });

      this.openSendAttachmentModal = function(event) {
        if (hasAttachments()) {
          if (event) event.preventDefault();

          var both = {
            label: "Enviar os dois arquivos",
            url: "mailto:?body=" + attachments.map(function(i) {
              return i.url;
            }).join(" "),
          };

          var items = attachments.map(function(a) {
            return { label: a.label, url: "mailto:?body=" + a.url };
          });

          items.push(both);

          openAttachmentsModal(items);
        }
      };

      this.openViewAttachmentModal = function(event) {
        if (hasAttachments()) {
          if (event) event.preventDefault();
          openAttachmentsModal(attachments);
        }
      };

      function hasAttachments() {
        return !!attachments && attachments.length >= 2;
      }

      function openAttachmentsModal(attachments) {
        $uibModal.open({
          template: "<div class='list-group'>" +
            "<a class='list-group-item'" +
              " ng-bind='attachment.label'" +
              " ng-click='$dismiss()'" +
              " ng-href='{{attachment.url}}'" +
              " ng-repeat='attachment in attachments'" +
              " target='_blank'></a>" +
          "</div>",
          controller: ["$scope", function($scope) {
            $scope.attachments = attachments;
          }],
          size: "sm",
        }).result.then(null, function() {}); // avoid warning for unhandled rejected promise
      }
    },
  ])
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/marketables-show-controller.js